import $ from "jquery"
import "bootstrap/js/dist/modal"

class Overlay {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("Overlay::initialize()")

		if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
			$("body").on("shown.bs.modal", ".bb-overlay", (e) => {
				this._setIosOverlayHeight($(e.target))
			})

			$(window).on("resize", () => {
				this._setIosOverlayHeight($(".bb-overlay.show").first())
			})
		}
	}

	_setIosOverlayHeight($overlay) {
		const $dialog = $overlay.find(".modal-dialog")

		if ($overlay.length) {
			$dialog.removeAttr("style")

			const maxHeight = window.innerHeight - $dialog[0].offsetTop * 2
			$overlay.find(".modal-dialog").css("max-height", maxHeight + "px")
		}
	}
}

export default Overlay
